const sportId = process.env.SPORT_ID

if (sportId == null) {
  throw new Error('"process.env.SPORT_ID" is not specified')
}
console.log(`Using SPORT_ID="${sportId}"`)

export default sportId
